import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

type Course = { id: string; slug: string; title: string; description: string | null; jlpt_level: string };

export default function Courses() {
  const [list, setList] = useState<Course[]>([]);

  useEffect(() => {
    supabase.from("courses").select("*").eq("published", true).order("sort_order").then(({ data }) => {
      setList((data as any) || []);
    });
  }, []);

  const byLevel: Record<string, Course[]> = {};
  for (const c of list) (byLevel[c.jlpt_level] ||= []).push(c);
  const levels = ["N5", "N4", "N3", "N2", "N1"].filter((l) => byLevel[l]);

  return (
    <div className="space-y-8 max-w-5xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold">Courses</h1>
        <p className="text-muted-foreground">Structured Japanese learning from N5 to N1.</p>
      </div>
      {levels.map((lvl) => (
        <section key={lvl} className="space-y-3">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            JLPT <Badge>{lvl}</Badge>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {byLevel[lvl].map((c) => (
              <Link key={c.id} to={`/courses/${c.slug}`}>
                <Card className="hover:shadow-md transition-shadow h-full">
                  <CardHeader>
                    <CardTitle className="text-base">{c.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground line-clamp-3">{c.description}</p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </section>
      ))}
      {!list.length && <p className="text-muted-foreground">No courses yet. Check back soon.</p>}
    </div>
  );
}
